import img11 from '../../../images/avs-slideshow-maker/power-img1-1.png'
import img11x2 from '../../../images/avs-slideshow-maker/power-img1-1@2x.png'
import img12 from '../../../images/avs-slideshow-maker/power-img1-2.png'
import img12x2 from '../../../images/avs-slideshow-maker/power-img1-2@2x.png'
import img13 from '../../../images/avs-slideshow-maker/power-img1-3.png'
import img13x2 from '../../../images/avs-slideshow-maker/power-img1-3@2x.png'

import img21 from '../../../images/avs-slideshow-maker/power-img2-1.png'
import img21x2 from '../../../images/avs-slideshow-maker/power-img2-1@2x.png'
import img22 from '../../../images/avs-slideshow-maker/power-img2-2.png'
import img22x2 from '../../../images/avs-slideshow-maker/power-img2-2@2x.png'
import img23 from '../../../images/avs-slideshow-maker/power-img2-3.png'
import img23x2 from '../../../images/avs-slideshow-maker/power-img2-3@2x.png'

import img31 from '../../../images/avs-slideshow-maker/power-img3-1.png'
import img31x2 from '../../../images/avs-slideshow-maker/power-img3-1@2x.png'
import img32 from '../../../images/avs-slideshow-maker/power-img3-2.png'
import img32x2 from '../../../images/avs-slideshow-maker/power-img3-2@2x.png'
import img33 from '../../../images/avs-slideshow-maker/power-img3-3.png'
import img33x2 from '../../../images/avs-slideshow-maker/power-img3-3@2x.png'

const powers = [
    {
        id: 1,
        title: "Save precious memories",
        desc:
            `Make birthday videos, holiday greeting cards, 
            a vacation trip overview and feature other family events and gatherings in a personalized slideshow. 
            Share your experience and make your loved ones feel special.`,
        img: [
            {
                id: '1.1',
                md: img11,
                lg: img11x2
            },
            {
                id: '1.2',
                md: img12,
                lg: img12x2
            },
            {
                id: '1.3',
                md: img13,
                lg: img13x2
            },
        ]
    },
    {
        id: 2,
        title: "Promote your brand",
        desc:
            `Cultivate your personal brand showcasing yourself and your work to potential customers. 
            Introduce new products and services, build anticipation for your upcoming launches. 
            Reach wider awareness on social media and gain a larger number of loyal customers and followers.`,
        img: [
            {
                id: '2.1',
                md: img21,
                lg: img21x2
            },
            {
                id: '2.2',
                md: img22,
                lg: img22x2
            },
            {
                id: '2.3',
                md: img23,
                lg: img23x2
            },
        ]
    },
    {
        id: 3,
        title: "Create engaging content",
        desc:
            `With a slideshow you can tell your story in a concise way without going into too many details. 
            It also helps to keep your target audience hooked and emotionally involved.`,
        img: [
            {
                id: '3.1',
                md: img31,
                lg: img31x2
            },
            {
                id: '3.2',
                md: img32,
                lg: img32x2
            },
            {
                id: '3.3',
                md: img33,
                lg: img33x2
            },
        ]
    },
]

export default powers
